var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05001 18.425C2.86667 18.2416 2.77084 18.0291 2.76251 17.7875C2.75417 17.5458 2.84167 17.3333 3.02501 17.15L8.15001 12.025C8.50001 11.675 8.92501 11.5 9.42501 11.5C9.925 11.5 10.35 11.675 10.7 12.025L13.225 14.55L18.525 9.27498H16.5C16.245 9.27498 16.0313 9.18923 15.8588 9.01775C15.6863 8.84625 15.6 8.63375 15.6 8.38025C15.6 8.12673 15.6863 7.91248 15.8588 7.73748C16.0313 7.56248 16.245 7.47498 16.5 7.47498H20.7C20.955 7.47498 21.1688 7.56122 21.3413 7.73373C21.5138 7.90623 21.6 8.11998 21.6 8.37498V12.575C21.6 12.83 21.5143 13.0437 21.3428 13.2162C21.1713 13.3887 20.9588 13.475 20.7053 13.475C20.4518 13.475 20.2375 13.3911 20.0625 13.2234C19.8875 13.0557 19.8 12.8479 19.8 12.6V10.55L14.5 15.85C14.15 16.2 13.725 16.375 13.225 16.375C12.725 16.375 12.3 16.2 11.95 15.85L9.42501 13.3L4.32501 18.425C4.14167 18.6083 3.92917 18.7 3.68751 18.7C3.44584 18.7 3.23334 18.6083 3.05001 18.425Z",
    fill: "#E20000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.eb4497e653924a7f7c55a808daf79273.svg";
export { ForwardRef as ReactComponent };